import { lazy } from 'react';
import Loadable from 'components/Loadable';

const LeaveDashboard = Loadable(lazy(() => import('./components/leave-dashboard/LeaveDashboard')));
const LeaveApplications = Loadable(lazy(() => import('./components/leave-applications/LeaveApplications')));
const LeaveApproval = Loadable(lazy(() => import('./components/leave-approval/LeaveApproval')));
const LeaveTypes = Loadable(lazy(() => import('./components/leave-types/LeaveTypes')));
const LeaveBalance = Loadable(lazy(() => import('./components/leave-balance/LeaveBalance')));
const LeavePolicy = Loadable(lazy(() => import('./components/leave-policy/LeavePolicy')));
const LeaveHolidayCalendar = Loadable(lazy(() => import('./components/holiday-calendar/HolidayCalendar')));
const LeaveRecurrenceMaster = Loadable(lazy(() => import('./components/recurrence-master/RecurrenceMaster')));
const CompensatoryOff = Loadable(lazy(() => import('./components/compensatory-off/CompensatoryOff')));
const LeaveEncashment = Loadable(lazy(() => import('./components/leave-encashment/LeaveEncashment')));
const LeaveReports = Loadable(lazy(() => import('./components/leave-reports/LeaveReports')));

export const leaveRoutes = {
  path: 'leave',
  children: [
    { index: true, element: <LeaveDashboard /> },
    { path: 'dashboard', element: <LeaveDashboard /> },
    { path: 'applications', element: <LeaveApplications /> },
    { path: 'approval', element: <LeaveApproval /> },
    { path: 'types', element: <LeaveTypes /> },
    { path: 'balance', element: <LeaveBalance /> },
    { path: 'policy', element: <LeavePolicy /> },
    { path: 'holiday-calendar', element: <LeaveHolidayCalendar /> },
    { path: 'recurrence-master', element: <LeaveRecurrenceMaster /> },
    { path: 'comp-off', element: <CompensatoryOff /> },
    { path: 'encashment', element: <LeaveEncashment /> },
    { path: 'reports', element: <LeaveReports /> }
  ]
};

export default leaveRoutes;
